import { SVGProps } from "react";

export function BagIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="48" height="48" rx="24" fill="black" fillOpacity="0.05" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5005 18V18.75H17.5134C16.5538 18.75 15.7491 19.4744 15.6487 20.4287L14.3855 32.4287C14.269 33.5358 15.137 34.5 16.2502 34.5H31.7509C32.8641 34.5 33.7322 33.5358 33.6156 32.4287L32.3525 20.4287C32.252 19.4744 31.4473 18.75 30.4878 18.75H28.5005V18C28.5005 15.5147 26.4858 13.5 24.0005 13.5C21.5152 13.5 19.5005 15.5147 19.5005 18ZM24.0005 15C22.3436 15 21.0005 16.3431 21.0005 18V18.75H27.0005V18C27.0005 16.3431 25.6573 15 24.0005 15ZM21.0005 23.25C21.0005 24.9069 22.3436 26.25 24.0005 26.25C25.6573 26.25 27.0005 24.9069 27.0005 23.25V22.5C27.0005 22.0858 27.3363 21.75 27.7505 21.75C28.1647 21.75 28.5005 22.0858 28.5005 22.5V23.25C28.5005 25.7353 26.4858 27.75 24.0005 27.75C21.5152 27.75 19.5005 25.7353 19.5005 23.25V22.5C19.5005 22.0858 19.8363 21.75 20.2505 21.75C20.6647 21.75 21.0005 22.0858 21.0005 22.5V23.25Z"
        fill="#7A7A7A"
      />
    </svg>
  );
}
